export default __webpack_public_path__ + "static/media/B_wdt_c_cap_3.0e769040.mp3";